import React from 'react';
import { Link } from 'react-router-dom';
import { CreditCardIcon, LogOutIcon } from 'lucide-react';
import { OrganiserPreferencesForm } from '../../components/organiser/OrganiserPreferencesForm';
import { AppearanceSetting } from '../../components/AppearanceSetting';
import { SettingsSection } from '../../components/SettingsSection';
import { useMarketplace } from '../../contexts/MarketplaceContext';
import { images } from '../../data/images';
import { baht, bookingFee } from '../../utils/format';
import { LanguageSwitcher } from '../../components/ui/LanguageSwitcher';
import { useLanguage } from '../../contexts/LanguageContext';
export function Account() {
  const {
    organiserPrefs,
    setOrganiserPrefs,
    offers,
    matches,
    getEvent
  } = useMarketplace();
  const {
    t
  } = useLanguage();
  const myAccepted = offers.filter(o => {
    const m = matches.find(x => x.id === o.matchId);
    return o.status === 'accepted' && m && getEvent(m.eventId)?.ownedByMe;
  });
  const feesPaid = myAccepted.reduce((sum, o) => sum + bookingFee(o.fee + o.travel), 0);
  return <div className="mx-auto w-full max-w-3xl px-5 pb-12 pt-6 lg:px-8 lg:pt-8" data-id="element-895" data-mp="emxn7go63wt8">
      <h1 className="text-[28px] font-bold tracking-[-0.015em]" data-id="element-896" data-mp="ektl949tx7vl">Account</h1>
      <div className="mt-6 flex items-center gap-4" data-id="element-897" data-mp="mmwqeqrsk8l">
        <img src={images.rooftop} alt="" className="h-16 w-16 rounded-full object-cover" data-id="element-898" data-mp="5lzisx9thna4" />
        <div data-id="element-899" data-mp="3n2po9t63tucm">
          <p className="text-lg font-bold" data-id="element-900" data-mp="3n27kmbh44duo">Halcyon Rooftop</p>
          <p className="text-sm text-ink-3" data-id="element-901" data-mp="3n0msesi9t6zz">Somchai Rattanakul · Thonglor, Bangkok</p>
        </div>
      </div>

      <div className="mt-8" data-id="element-902" data-mp="3rvafqo1jfvcz">
        <SettingsSection title="Matching preferences" description="These shape fit scores and who we suggest in Discover." data-id="element-903" data-mp="3e2uarhp2tn9f">
          <OrganiserPreferencesForm value={organiserPrefs} onChange={setOrganiserPrefs} data-id="element-904" data-mp="3i4fw7rfof9v8" />
        </SettingsSection>

        <SettingsSection title="Billing" description="Encorza charges a 6% booking fee (min ฿150) only when a performer accepts your offer." data-id="element-905" data-mp="344n7g1npn3pw">
          <dl className="grid grid-cols-2 gap-4 sm:max-w-md" data-id="element-906" data-mp="1emhpljc77jsl">
            <div data-id="element-907" data-mp="1eoue6fcgosem">
              <dt className="text-sm text-ink-3" data-id="element-908" data-mp="19w1a7totho3l">Confirmed bookings</dt>
              <dd className="tabular text-2xl font-bold" data-id="element-909" data-mp="19uq7zyb0soel">{myAccepted.length}</dd>
            </div>
            <div data-id="element-910" data-mp="15uo3zihtbiw5">
              <dt className="text-sm text-ink-3" data-id="element-911" data-mp="15s1vngn3kzcv">Booking fees this year</dt>
              <dd className="tabular text-2xl font-bold" data-id="element-912" data-mp="10x63mghv2bzr">{baht(feesPaid)}</dd>
            </div>
          </dl>
          <div className="mt-5 flex items-center gap-3 border-t border-line pt-4" data-id="element-913" data-mp="1xjhse3idc2gt">
            <CreditCardIcon className="h-5 w-5 text-ink-2" data-id="element-914" data-mp="1tkidbq2xapbn" />
            <p className="flex-1 text-[15px]" data-id="element-915" data-mp="1oke5spjzt4xk">Visa ending 4421 · PromptPay linked</p>
            <button type="button" className="text-sm font-bold text-brand-strong hover:underline" data-id="element-916" data-mp="1jm2xij9cj2hg">
              Change
            </button>
          </div>
        </SettingsSection>

        <SettingsSection title="Appearance" data-id="element-917" data-mp="d3e7ndayrvvm">
          <AppearanceSetting data-id="element-918" data-mp="85me6euo81pb" />
        </SettingsSection>

        <SettingsSection title={t('settings.language')} description={t('settings.languageHint')} data-id="element-919" data-mp="3u84w8jx42wez">
          <LanguageSwitcher id="account-lang" data-id="element-920" data-mp="31tok4xlixeo" />
        </SettingsSection>

        <SettingsSection title="Session" data-id="element-921" data-mp="323fpvudnaly">
          <Link to="/" className="inline-flex items-center gap-2 font-bold text-ink-2 hover:text-ink" data-id="element-922" data-mp="80dcgavr2j9o">
            <LogOutIcon className="h-4 w-4" data-id="element-923" data-mp="cs56ive4774k" /> Sign out
          </Link>
        </SettingsSection>
      </div>
    </div>;
}